export default {
  templates: [],
  templatesByKeywords: [],
  template: {},
  postsUser: [],
  isLoading: false
};
